import { useSelector } from 'react-redux';

export function useOnlineOrderingDisplayLocationInformationOnLayout() {
  const displayLocationInformationOnLayout = useSelector(
    state =>
      state.account?.online_ordering_general_settings
        ?.display_location_information_on_layout ?? false
  );

  return displayLocationInformationOnLayout;
}
